import type { BrandConfig } from '@/config/brands/types';
import type { ResellerPartnerConfig } from '@/config/reseller-partners';

/** Map a legacy code-only reseller entry onto a base brand config. */
export const mergeCodeResellerBrand = (
  base: BrandConfig,
  reseller: ResellerPartnerConfig,
): BrandConfig => ({
  ...base,
  appName: reseller.brandName,
  companyName: reseller.brandName,
  logo: reseller.logo,
  ...(reseller.logoDark ? { logoDark: reseller.logoDark } : {}),
});
